import { Link } from 'react-router-dom';
import { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import '../css/new.css'; // Custom styles
import logo from '../images/logos.png';

function FullNavbar() {
  const [expanded, setExpanded] = useState(false);

  const handleNavItemClick = () => {
    setExpanded(false);
  };

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <Navbar expand="lg" className="custom-navbar" sticky="top" expanded={expanded}>
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="brand" onClick={handleNavItemClick}>
          <img src={logo} alt="A S Traders Logo" /> <span>A S TRADERS</span>
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="navbar-nav"
          style={{ color: 'black' }}
          onClick={handleToggle}
        />

        <Navbar.Collapse id="navbar-nav" className="navigate">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" onClick={handleNavItemClick}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/About" onClick={handleNavItemClick}>
              About
            </Nav.Link>

            <NavDropdown title="Products" id="products-dropdown">
              <NavDropdown.Item as={Link} to="/pvc-panel" onClick={handleNavItemClick}>
                PVC Panel
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/wallpaper" onClick={handleNavItemClick}>
                Wallpaper
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/grass" onClick={handleNavItemClick}>
                Grass
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/flooring" onClick={handleNavItemClick}>
                Flooring
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/wooden-flooring" onClick={handleNavItemClick}>
                Wooden Flooring
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/plank" onClick={handleNavItemClick}>
                Plank
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/foam-sheet" onClick={handleNavItemClick}>
                Foam Sheet
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/pvc-door" onClick={handleNavItemClick}>
                PVC Door
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/wooden-door" onClick={handleNavItemClick}>
                Wooden Door
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/aluminium-door" onClick={handleNavItemClick}>
                Aluminium Door
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/pvc-false-ceiling" onClick={handleNavItemClick}>
                PVC False Ceiling
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/gypsum-false-ceiling" onClick={handleNavItemClick}>
                Gypsum False Ceiling
              </NavDropdown.Item>

              <NavDropdown.Item as={Link} to="/gypsum-false-ceiling" onClick={handleNavItemClick}>
                Louvers panel
              </NavDropdown.Item>

              <NavDropdown.Item as={Link} to="/gypsum-false-ceiling" onClick={handleNavItemClick}>
                Flute panel
              </NavDropdown.Item>

              <NavDropdown.Item as={Link} to="/gypsum-false-ceiling" onClick={handleNavItemClick}>
                UV marble sheet
              </NavDropdown.Item>


            </NavDropdown>

            <Nav.Link as={Link} to="/gallery" onClick={handleNavItemClick}>
              Gallery
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" onClick={handleNavItemClick}>
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default FullNavbar;